module.exports = __webpack_public_path__ + "img/b.b44cd051.jpg";